/** @format */

import React, { Suspense } from "react";

//layoutpages
import EmployerLayout from "../layouts/dashboard/emp-layout";
import UserLayout from "../layouts/dashboard/user-layout";

import { ProtectedRouter } from "../configs/routes.config/user-protected-route";
import { EmpProtectedRouter } from "../configs/routes.config/employer-protected-route";
import { PublicRouter } from "../configs/routes.config/public-route";
import PublicLayout from "../layouts/dashboard/public-layout";

export const UserRouters = [
  {
    path: "u",
    element: <UserLayout />,
    children: [...ProtectedRouter],
  },
];
export const EmployerRouters = [
  {
    path: "e",
    element: <EmployerLayout />,
    children: [...EmpProtectedRouter],
  },
];
export const PublicRouters = [
  {
    element: <PublicLayout />,
    children: [...PublicRouter],
  },
];
